import { Link } from "react-router-dom";
import { AnimatedSection } from "@/components/common/AnimatedSection";
import { ArrowRight } from "lucide-react";

const destinations = [
  { name: "Maldives", tagline: "Overwater paradise", image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=700&q=80", tours: 3 },
  { name: "Paris", tagline: "City of Light", image: "https://images.unsplash.com/photo-1431274172761-fca41d930114?w=700&q=80", tours: 5 },
  { name: "Dubai", tagline: "Modern marvels", image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=700&q=80", tours: 4 },
  { name: "Bali", tagline: "Island of Gods", image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=700&q=80", tours: 6 },
  { name: "Santorini", tagline: "Aegean gem", image: "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=700&q=80", tours: 4 },
  { name: "Swiss Alps", tagline: "Mountain majesty", image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=700&q=80", tours: 3 },
];

export const FeaturedDestinations = () => {
  return (
    <section className="bg-white section-padding" data-testid="featured-destinations">
      <div className="container-wide px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <div className="flex items-end justify-between mb-10">
            <div>
              <p className="overline mb-3">Explore the World</p>
              <h2 className="heading-lg text-primary">Popular Destinations</h2>
            </div>
            <Link
              to="/tours"
              className="hidden sm:flex items-center gap-1.5 text-sm font-semibold text-accent hover:text-primary transition-colors"
              data-testid="destinations-view-all"
            >
              View all <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {destinations.map((dest, i) => (
            <AnimatedSection key={dest.name} delay={i * 0.06}>
              <Link
                to="/tours"
                className="group relative block overflow-hidden rounded-xl aspect-[3/4] sm:aspect-[4/5]"
                data-testid={`destination-${dest.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <img
                  src={dest.image}
                  alt={dest.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.2,0,0,1)] group-hover:scale-105"
                  loading={i < 2 ? "eager" : "lazy"}
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-5">
                  <p className="text-xs text-white/70 font-medium mb-1">{dest.tagline}</p>
                  <h3 className="text-lg sm:text-xl font-bold text-white leading-tight">{dest.name}</h3>
                  <p className="text-xs text-white/60 mt-1">{dest.tours} tours available</p>
                </div>
                {/* Hover arrow */}
                <div className="absolute top-3 right-3 h-8 w-8 rounded-full bg-white/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 backdrop-blur-sm">
                  <ArrowRight className="h-3.5 w-3.5 text-white" />
                </div>
              </Link>
            </AnimatedSection>
          ))}
        </div>

        <Link
          to="/tours"
          className="sm:hidden flex items-center justify-center gap-2 text-sm font-semibold text-accent mt-6 hover:text-primary transition-colors"
          data-testid="destinations-view-all-mobile"
        >
          View All Destinations <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
};
